import styled, { css } from 'styled-components';
import { Row } from 'components';

export const StyledHeaderCell = styled.div`
  min-width: ${({ isAction }) => (isAction ? '10rem' : '14rem')};
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  height: 90px;
`;

export const FilterRow = styled(Row)`
  min-height: 40px;
  align-items: center;
  justify-content: center;
  .header-filter {
    min-height: 30px;
  }
`;

export const LabelSortRow = styled.div`
  min-height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Label = styled.span`
  display: flex;
  align-items: center;
  justify-content: ${({ labelAlign }) => labelAlign};
  flex: ${({ isAction }) => (isAction ? '1 1 50%' : '1 1 75%')};
  text-align: ${({ labelAlign }) => labelAlign};
`;

export const SortWrapper = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: ${({ isAction }) => (isAction ? '1 1 50%' : '1 1 25%')};
  max-height: 22px;
  & svg {
    height: 22px;
    width: 22px;
    display: block;
    vertical-align: middle;
  }
`; 